module.exports = __webpack_public_path__ + "img/false.472ce4f.png";